import PropTypes from "prop-types";
import React, { Component } from "react";
import ajax from "superagent";
import _ from "lodash";
import ResultContainer from "./ResultContainer";
import SelfieUploadPopup from "./SelfieUploadPopup/index";
import { SelfieSearchContext } from "./SelfieSearchContext";
const whiteUpload = require("../images/white-upload.svg");
const selfieSearchImg = require("../images/selfie-search-img.png");
const selfieSearchImg2x = require("../images/selfie-search-img-2x.png");
import { Cart, Filters, Photo } from "./types";
import {
  getCookie,
  setCookie,
  deleteCookie
} from "../../../utils/BrowserHelper";
import "../styles/styles.css";

interface SelfieSearchProps {
  photosAPI: string;
  addToCartAPI: string;
  removeFromCartAPI: string;
  cart: Cart;
  initialFilters: Filters;
  adminUser: boolean;
  embedded: boolean;
  ios: boolean;
  selfieSearchS3Bucket: string;
  currentUserId: number;
  currentUserCountry: string;
  openPopup: boolean;
  onSelfiePopupClose: () => void;
  showUploadSelfieBanner: boolean;
  pageConfiguration: {
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
  };
}

interface SelfieSearchState {
  cart: Cart;
  selfieUploadPopup: boolean;
  initialFilters: Filters;
  imageUploaded: boolean;
}

class MasterSearchContainer extends Component<
  SelfieSearchProps,
  SelfieSearchState
> {
  constructor(props: SelfieSearchProps) {
    super(props);
    this.state = {
      cart: props.cart,
      selfieUploadPopup: props.openPopup && !getCookie("reference_image"),
      initialFilters: {
        ...props.initialFilters,
        referenceImage: getCookie("reference_image") || null
      },
      imageUploaded: !!getCookie("reference_image")
    };
  }

  public componentDidMount() {
    $(".selfie-start").ready(() => {
      $("#selfie-start-placeholder").hide();
    });
  }

  public render() {
    return (
      <SelfieSearchContext.Provider
        value={{
          adminUser: this.props.adminUser,
          selfieSearchS3Bucket: this.props.selfieSearchS3Bucket,
          currentUserId: this.props.currentUserId,
          currentUserCountry: this.props.currentUserCountry,
          openSelfieUploadPopup: this.openSelfieUploadPopup,
          referenceImage: this.state.initialFilters.referenceImage,
          pageConfiguration: this.props.pageConfiguration
        }}
      >
        <div>
          <div className="dv-galsection ns">
            {this.state.imageUploaded ? (
              <ResultContainer
                photosAPI={this.props.photosAPI}
                cart={this.state.cart}
                addPhotoToCart={this.addPhotoToCart}
                removePhotoFromCart={this.removePhotoFromCart}
                initialFilters={this.state.initialFilters}
                updateImageFilter={this.updateImageFilter}
              />
            ) : (
              this.props.showUploadSelfieBanner && (
                <UploadSelfieBanner
                  openSelfieUploadPopup={this.openSelfieUploadPopup}
                />
              )
            )}{" "}
          </div>
          {/* {this.props.embedded && <EmbedHeader cart={this.state.cart} />} */}
          {this.state.selfieUploadPopup && (
            <SelfieUploadPopup
              updateImageFilter={this.updateImageFilter}
              closePopup={() => {
                this.setState({
                  selfieUploadPopup: false
                });
                this.props.onSelfiePopupClose &&
                  this.props.onSelfiePopupClose();
              }}
              hideUploadSelfie={false}
            />
          )}
        </div>
      </SelfieSearchContext.Provider>
    );
  }

  private addPhotoToCart = (photo: Photo) => {
    if (
      this.props.cart &&
      photo.album.event.currency !== this.props.cart.currency &&
      this.props.cart.photos.length > 0
    ) {
      // @ts-ignore
      toastr.error(
        `The cart can only contain photos in one currency, currently ${photo.album.event.currency}. Clear and try adding again.`
      );
    } else {
      this.setState({
        cart: {
          ...this.state.cart,
          photos: _.concat(
            this.state.cart ? this.state.cart.photos : 0,
            photo.id
          ),
          currency: photo.album.event.currency
        }
      });

      // @ts-ignore
      (window.dataLayer || []).push({ event: "addToCart" });

      ajax
        .post(this.props.addToCartAPI)
        .send({
          photo_id: photo.id,
          cart_id: this.state.cart ? this.state.cart.id : null
        })
        .then(res => {
          this.setState(
            {
              cart: res.body.cart
            },
            () => {
              $.getScript("/cart_sales_count");
              // @ts-ignore
              toastr.success("Added to cart", null, { timeOut: 1000 });
            }
          );
        })
        .catch(err => console.log(err));
    }
  };

  private removePhotoFromCart = (photo: Photo) => {
    this.setState({
      cart: {
        ...this.state.cart,
        photos: _.without(this.state.cart.photos, photo.id)
      }
    });

    ajax
      .delete(this.props.removeFromCartAPI)
      .send({ photo_id: photo.id })
      .then(() => {
        $.getScript("/cart_sales_count");
        // @ts-ignore
        toastr.success("Removed from cart", null, {
          timeOut: 1000
        });
      })
      .catch(err => console.log(err));
  };

  private openSelfieUploadPopup = () => {
    this.setState({
      selfieUploadPopup: true
    });
  };

  private updateImageFilter = (imageURL: string, clearSelfie: boolean) => {
    clearSelfie
      ? this.setState(
          {
            initialFilters: {
              ...this.state.initialFilters,
              referenceImage: null
            },
            imageUploaded: false,
            selfieUploadPopup: true
          },
          () => {
            deleteCookie("reference_image");
          }
        )
      : this.setState(
          {
            initialFilters: {
              ...this.state.initialFilters,
              referenceImage: imageURL
            },
            imageUploaded: true,
            selfieUploadPopup: false
          },
          () => {
            setCookie("reference_image", imageURL);
          }
        );
  };
}

const UploadSelfieBanner = ({
  openSelfieUploadPopup
}: {
  openSelfieUploadPopup: () => void;
}) => (
  <div className="dv-galsection-empty selfie-start">
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-3 text-left selfie-content">
          <h2 className="highlighted">
            Find photos that match your <span>selfie!</span>
          </h2>
          <p>
            Search across events that you have purchased photos from for more
            photos of you
          </p>
          <button className="btn primary-btn" onClick={openSelfieUploadPopup}>
            <img src={whiteUpload} alt="white-upload" /> Upload Selfie
          </button>
        </div>
        <div className="col-md-8 selfie-img hidden-xs hidden-sm">
          <img srcSet={`${selfieSearchImg}, ${selfieSearchImg2x} 2x`} alt="" />
        </div>
      </div>
      <h6 className="text-center smallprint gallery-terms-small">
        View and re-download photos that you have purchased. By purchasing these
        photos you agree to the{" "}
        <a href="https://geosnapshot.com/terms_and_conditions" target="_blank">
          terms and conditions
        </a>
        .
      </h6>
    </div>
  </div>
);

export default MasterSearchContainer;
